export const ASSIGN_OFFER = gql`
    mutation AssignOffer($partnerIds: [Int], $offerId: Int!, $type: AssignmentType!) {
        updateOfferAssignees(partnerIds: $partnerIds, offerId: $offerId, type: $type) {
            id
            offerName
        }
    }
`;

export const ASSIGN_OFFER_PARTNER_OF_PARTNERS = gql`
    mutation AssignOfferPartnerOfPartner(
        $partnerOfPartnerIds: [Int]
        $offerId: Int!
        $type: AssignmentType!
    ) {
        updateOfferAssigneesPartnerOfPartner(
            partnerOfPartnerIds: $partnerOfPartnerIds
            offerId: $offerId
            type: $type
        ) {
            id
            offerName
        }
    }
`;
